import { Mixins, Component } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/match';
import pageMixin from '../../../mixins/pageMixin';

@Component
export default class tableMixin extends Mixins(pageMixin) {
  private mList: Array<any> = [];

  private column: Array<ITABLECOLCONF> = [{
    label: '序号',
    prop: 'index',
    align: 'center',
    width: '50px',
    tooltip: true,
  }, {
    label: '比赛名称',
    align: 'center',
    prop: 'title',
    width: '320px',
  }, {
    label: '赛事邀请码',
    prop: 'invitationCode',
    align: 'center',
    width: '150px',
  }, {
    label: '老师邀请码',
    prop: 'adviserInvitationCode',
    align: 'center',
    width: '150px',
  }, {
    label: '评审老师邀请码',
    prop: 'judgeInvitationCode',
    align: 'center',
    width: '150px',
  }, {
    label: '赛事性质',
    align: 'center',
    custom: true,
    prop: 'quality',
    width: '100px',
    tags: [{
      value: '0',
      type: 'warning',
      label: '私有',
    }, {
      value: '1',
      type: 'primary',
      label: '公开',
    }],
  }, {
    label: '赛事状态',
    align: 'center',
    custom: true,
    prop: 'status',
    width: '100px',
    tags: [{
      value: '0',
      type: 'info',
      label: '未发布',
    }, {
      value: '1',
      type: 'success',
      label: '已发布',
    }, {
      value: '2',
      type: 'primary',
      label: '准备中',
    }, {
      value: '3',
      type: 'primary',
      label: '进行中',
    }, {
      value: '4',
      type: 'danger',
      label: '评审中',
    }, {
      value: '99',
      type: 'info',
      label: '已结束',
    }],
  }, {
    label: '申报时间',
    align: 'center',
    custom: true,
    width: '200px',
    tag: {
      type: 'info',
      prop: ['declarationTime'],
    },
  }, {
    label: '评审时间',
    align: 'center',
    custom: true,
    width: '200px',
    tag: {
      type: 'info',
      prop: ['reviewTime'],
    },
  }, {
    label: '终审时间',
    align: 'center',
    custom: true,
    width: '200px',
    tag: {
      type: 'info',
      prop: ['auditTime'],
    },
  }, {
    label: '结束时间',
    align: 'center',
    custom: true,
    width: '200px',
    tag: {
      type: 'info',
      prop: ['endTime'],
    },
  }, {
    label: '主办单位',
    align: 'center',
    prop: 'sponsor',
    width: '200px',
  }, {
    label: '协办单位',
    align: 'center',
    prop: 'coOrganizer',
    width: '200px',
  }, {
    label: '承办单位',
    align: 'center',
    prop: 'organizer',
    width: '200px',
  }, {
    label: '操作',
    custom: true,
    minWidth: '120',
    maxBtn: 2,
    fixed: 'right',
    btnList: [
      {
        title: '发布',
        name: '/match/manage:update',
        handleDis: (row: any) => !!row.status,
        handleTitle: (row: any) => {
          if (row.status) return '已发布';
          return '发布';
        },
        icon: 'edit',
        type: 'info',
        callback: this.handleRelese,
        log: {
          name: '赛事管理 - 发布',
          component: 'match/manage/tableMixin',
        },
      },
      {
        title: '修改',
        name: '/match/manage:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleUpdateForm,
        log: {
          name: '赛事管理 - 修改',
          component: 'match/manage/tableMixin',
        },
      },
      {
        title: '查询工作人员',
        name: '',
        icon: 'search',
        type: 'info',
        callback: this.handleEmployee,
      },
      {
        title: '查询参赛人员',
        name: '',
        icon: 'search',
        type: 'info',
        callback: this.handleUser,
      },
      {
        title: '停止',
        name: '/match/manage:stop',
        icon: 'remove',
        type: 'info',
        callback: this.handleStop,
        log: {
          name: '赛事管理 - 停止',
          component: 'match/manage/tableMixin',
        },
      },
      {
        title: '删除',
        name: '/match/manage:remove',
        icon: 'remove',
        type: 'info',
        callback: this.handleRmove,
        log: {
          name: '赛事管理 - 删除',
          component: 'match/manage/tableMixin',
        },
      },
    ],
    align: 'center',
  },
  ];

  private loading: boolean = true;

  mounted() {
    this.getData();
  }

  /* eslint-disable class-methods-use-this */
  /**
   * @author liangyongmou
   * @desc 获取机构列表
   */
  getData() {
    api.getMList(this.page).then((res: any) => {
      res.content.map((el:any, index: any) => {
        const data = el;
        data.index = res.number * res.size + index + 1;
        return el;
      });
      this.mList = res.content;
      console.log(this.mList);
      this.mList.map((el: any) => {
        if (el.quality === 1) {
          el.invitationCode = '-';
        } else {
          el.adviserInvitationCode = '-';
        }
      });
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  /* eslint-disable class-methods-use-this */
  handleUpdateForm(row: any) {}

  handleEmployee(row: any) {}

  handleUser(row: any) {}

  handleRelese(row: any) {
    this.confirm('此操作将发布该赛事, 是否继续?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.releseMatch(row.pid).then(() => {
        this.getData();
        close();
        this.$log({
          title: '赛事管理 - 发布 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '赛事管理 - 发布 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }

  /**
   * @author liangyongmou
   * @desc 删除机构操作
   * @param { any } row 行数据
  */
  handleStop(row: any) {
    this.confirm('此操作将停止该赛事, 是否继续?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.stopMatch(row.pid).then(() => {
        this.getData();
        close();
        this.$log({
          title: '赛事管理 - 停止 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '赛事管理 - 停止 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }

  /**
   * @author liangyongmou
   * @desc 删除机构操作
   * @param { any } row 行数据
  */
  handleRmove(row: any) {
    this.confirm('此操作将删除该赛事, 是否继续?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeMatch(row.pid).then(() => {
        this.getData();
        close();
        this.$log({
          title: '赛事管理 - 删除 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '赛事管理 - 删除 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }
}
